import * as React from "react";
import {Button, EmptyState, icons} from "@vebox/etui-core";
import {AppTranslations, ErrorMessages} from "../components/Utils/translations/AppTranslations";
import {IconGlyph} from "@vebox/etui-core/ts/Icon/Icon.types";

declare var AppTranslations: AppTranslations;

interface DefaultErrorBoundaryFallbackProps {
    errorMessage?: string;
    errorTitle?: string;
    onClose?: () => void;
    style?: React.CSSProperties
    icon?: IconGlyph
}

export const VBX_SUPPORT_ADDRESS = "WCS.aiconnexio@wipro.com"

const getDefaultErrorMessage = (errorMessages: ErrorMessages): string => {
    const {
        somethingWentWrong,
        tryAgainLaterMessage,
        persistingErrorSupport
    } = errorMessages
    return `${somethingWentWrong}, ${tryAgainLaterMessage.toLowerCase()}.`;
}
const getSubDefaultErrorMessage = (errorMessages: ErrorMessages): string => {
    const {
        persistingErrorSupport
    } = errorMessages
    return `${persistingErrorSupport}`;
}

export const DefaultErrorBoundaryFallback: React.FC<DefaultErrorBoundaryFallbackProps> = ({
                                                                                              errorTitle,
                                                                                              errorMessage,
                                                                                              onClose,
                                                                                              icon,
                                                                                              style
                                                                                          }) => {
    const {unexpectedError} = AppTranslations.errorMessages
    const DEFAULT_ERROR_MESSAGE = getDefaultErrorMessage(AppTranslations.errorMessages)
    const DEFAULT_SUB_ERROR_MESSAGE = getSubDefaultErrorMessage(AppTranslations.errorMessages);

    // @ts-ignore
    const errorMessageToDisplay: string = errorMessage ?? DEFAULT_ERROR_MESSAGE;
    const errorTitleToDisplay: string = errorTitle ?? unexpectedError;

    return <div className={"wrapper fill-parent centered emptyTitlesContainer"} style={style}>
        <EmptyState>
            <EmptyState.Icon size={144} glyph={icon ?? icons.ERROR_CIRCLE}/>
            <EmptyState.Title>
                {errorTitleToDisplay}
            </EmptyState.Title>
            <EmptyState.SubTitle>
                {errorMessageToDisplay}
            </EmptyState.SubTitle>
            <div className={"padding-top-10"}>
                <EmptyState.SubTitle>
                    {DEFAULT_SUB_ERROR_MESSAGE}
                </EmptyState.SubTitle>
            </div>
        </EmptyState>
    </div>
}